import React from 'react'
import { BonusBundleTemplate } from '@components'

import spritesheetSrc from '@assets/bonus-system/gift-animation.png'
import animatedSpriteConfig from '@assets/bonus-system/gift-animation.json'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import { Bonus } from 'game-ui-types'
import { BonusBundleStyles } from '@components/BonusSystemCommon/content/BonusBundleTemplate'
import backgroundImage from '@assets/bonus-system/background-listitem.svg'
import { AnimatedSprite } from '@amusnet/react-ui'

interface FSMultipleBonusesProps {
    setSelectedBonus: (bonus: Bonus) => void
}

const FSMultipleBonuses: React.FC<FSMultipleBonusesProps> = ({ setSelectedBonus }: FSMultipleBonusesProps) => {
    const bonuses = useFreeSpinsBonusesStore((state) => state.bonuses)
    const declinedBonusesIds = useFreeSpinsBonusesStore((state) => state.declinedBonusesIds)
    const setActiveBonus = useFreeSpinsBonusesStore((state) => state.setActiveBonus)
    const setBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const setBonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.setBonusSystemDeclineState)

    const bonusBundleStyles: BonusBundleStyles = {
        primaryTextColor: '#FFD100',
        secondaryTextColorBundle: '#FFFFFF',
        playBtnColor: '#A6CE39',
        playLaterBtnColor: '#FFFFFF',
        declineBtnColor: '#D9D9D9',
        border: '',
        background: `url("${backgroundImage}") no-repeat center`,
    }

    return (
        <div id="fs-multiple-bonuses" className="flex flex-col items-center justify-between">
            <div id="fs-multiple-bonuses-content" className="flex flex-col w-full bg-[#19191C]">
                <AnimatedSprite
                    spritesheetSrc={spritesheetSrc}
                    config={animatedSpriteConfig}
                    duration={1.5}
                    className="m-auto"
                />
                <div
                    id="fs-multiple-bonuses-body"
                    className="flex flex-col items-center w-full h-[384px] py-[15px] bg-[linear-gradient(180deg,#19191C_19.44%,#793F06_100%)]"
                >
                    <div
                        id="fs-multiple-bonuses-list"
                        className="w-[650px] max-h-[355px] px-[10px] pt-[10px] bg-[#000000] overflow-x-hidden rounded-[8px] touch-auto"
                    >
                        {bonuses.map((bonus, index) => (
                            <BonusBundleTemplate
                                elementId={`bonus-${bonus.id}`}
                                key={index}
                                bonus={bonus}
                                setSelectedBonus={setSelectedBonus}
                                declinedBonusesIds={declinedBonusesIds}
                                styles={bonusBundleStyles}
                                setActiveBonus={setActiveBonus}
                                setBonusSystemState={setBonusSystemState}
                                setBonusSystemDeclineState={setBonusSystemDeclineState}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FSMultipleBonuses
